module.exports = __webpack_public_path__ + "965e241851541cd3fd70220615be2c1f.svg";